import { DEFAULT_CREATED_BY } from 'components/Inputs/CreatedBySelect/constants';
import { IQueryPointsData } from './types';

export const DEFAULT_POINT_QUERY: IQueryPointsData = {
  createdByData: { id: DEFAULT_CREATED_BY, name: DEFAULT_CREATED_BY },
  isDeleted: { id: 'false', name: 'notDeleted' },
  limit: 100,
};
